import {
    Accordion,
    AccordionSummary,
    Avatar,
    Grid,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useMediaQuery,
} from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import UserRole from '../../../../shared/AuthRoles';
import { useGetIndividualOwnerQuery } from '../../../../app/Slices/SevenDayApiSlice';
import VisibilityIcon from '@mui/icons-material/Visibility';
import React from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import SettingsIcon from '@mui/icons-material/Settings';

export default function OwnerExperiencesPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const navigate = useNavigate();
    const loggedInUser = UserRole();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const {
        data: getIndividualCompany,
        isFetching,
        error,
    } = useGetIndividualOwnerQuery(`owners/${loggedInUser?.company}`);

    const handleChange = (url: string) => (event: any) => {
        if (event?.type) {
            navigate(url);

            return;
        }
    };

    const ownerSettingList = [
        {
            settingName: 'Create new experience',
            settingDescription:
                'List your property, boat, vehicle, or activity to start earning and hosting unforgettable experiences on your terms!',
            settingUrl: '/newExperience',
            settingIcon: <AddCircleIcon />,
        },
        {
            settingName: 'Manage your listings',
            settingDescription:
                'View and edit your listing anytime — update details, adjust pricing, and manage availability to keep it fresh and bookable!',
            settingUrl: `/viewExperiences/all/${getIndividualCompany?.name
                ?.replace(/ /g, '')
                .toLowerCase()}`,
            settingIcon: <EditIcon />,
        },
        {
            settingName: 'Your Experience Settings',
            settingDescription:
                'Customize your experience with ease — manage your account, preferences, and notifications all in one place',
            settingUrl: '/adminCentre/host',
            settingIcon: <SettingsIcon />,
        },
        {
            settingName: 'View all Experiences',
            settingDescription:
                'View all available experiences on the platform to stay informed and optimize your own!',
            settingUrl: '/viewExperiences/all',
            settingIcon: <VisibilityIcon />,
        },
    ];

    useEffect(() => {
        if (loggedInUser?.role === 'owner_admin') {
            navigate(`/experiences`, { replace: true });
        } else {
            navigate(`/viewExperiences/all`, { replace: true });
        }
    }, []);

    return (
        <Grid
            sx={{
                width: '100%',
                height: isMobile ? '100%' : '80%',
                justifyContent: 'left',
                alignItems: 'center',
            }}
        >
            <Grid
                sx={{
                    width: '100%',
                    height: isMobile ? '2%' : '5%',
                    justifyContent: 'left',
                    display: 'flex',
                }}
            >
                <Typography
                    variant='h1'
                    sx={{
                        textAlign: 'left',
                        textTransform: 'uppercase',
                    }}
                >
                    Experiences
                </Typography>
            </Grid>
            <Grid
                sx={{
                    width: '100%',
                    minHeight: isMobile ? '65%' : '78%',
                    paddingTop: '30px',
                    // justifyContent: 'left',
                    // display: 'flex',
                    // flexDirection: isMobile ? 'column' : 'row',
                }}
            >
                {ownerSettingList.map((item: any) => (
                    <Accordion
                        expanded={false}
                        onChange={handleChange(item?.settingUrl)}
                        key={item?.settingName}
                        sx={{ borderRadius: '7px' }}
                    >
                        <AccordionSummary
                            expandIcon={<ArrowRightIcon />}
                            aria-controls='panel1a-content'
                            id='panel1a-header'
                        >
                            <Typography
                                component='h3'
                                variant='h6'
                                sx={{
                                    fontWeight: 550,
                                    // textTransform: 'uppercase',
                                }}
                            >
                                <ListItem>
                                    <ListItemAvatar>
                                        <Avatar>{item?.settingIcon}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                        primary={item?.settingName}
                                        secondary={item?.settingDescription}
                                    />
                                </ListItem>
                            </Typography>
                        </AccordionSummary>
                        {/* <AccordionDetails>{item.settingDescription}</AccordionDetails> */}
                    </Accordion>
                ))}
            </Grid>
        </Grid>
    );
}
